var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("section", { attrs: { id: "user" } }, [
      _c("div", { staticClass: "input_list" }, [
        _c("ul", [
          _c("li", [
            _c("span", [
              _c("label", { staticClass: "list_key" }, [
                _vm._v(_vm._s(_vm.label.email))
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "important small_text" }, [
                _vm._v("必須")
              ])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.accountForm.email,
                  expression: "accountForm.email",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "list_box",
              attrs: {
                type: "text",
                placeholder: "****@domans.co.jp",
                disabled: !_vm.isEdit,
                maxlength: "128"
              },
              domProps: { value: _vm.accountForm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.accountForm, "email", $event.target.value.trim())
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.email
              ? _c("label", { staticClass: "error_text" }, [
                  _vm._v(_vm._s(_vm.errors.email))
                ])
              : _vm._e()
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    Object.keys(_vm.errors).length > 0
      ? _c("div", { staticClass: "error_text" }, [
          _vm._v(
            "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ddf960a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddf960a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/user/DcAccountInput.vue
// module id = null
// module chunks = 